import { render, staticRenderFns } from "./shippingDetails.vue?vue&type=template&id=c7549962&scoped=true"
import script from "./shippingDetails.vue?vue&type=script&lang=js"
export * from "./shippingDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7549962",
  null
  
)

export default component.exports